import React from 'react';
import useSWR from 'swr';
import { formatDate } from '@/lib/format';
import * as P from '@/lib/portal/service';

// Verified dates only: start, latest published update, target completion. Nothing is estimated or interpolated.
export default function Timeline({ p }) {
  const upd = useSWR(p?.id ? ['updates', p.id] : null, () => P.updates(p.id));
  const latest = (upd.data || []).find((u) => u.published);
  const steps = [
    { k: 'start', label: 'Works commenced', date: p.start_date, done: Boolean(p.start_date) },
    { k: 'update', label: 'Latest site update', date: latest?.published_at, done: Boolean(latest), note: latest?.title },
    { k: 'finish', label: 'Target completion', date: p.target_finish_date, done: false },
  ];
  return (
    <section className="rounded-2xl border border-[#D8D0C4] bg-white px-6 py-6 md:px-8" data-testid="portal-timeline">
      <div className="text-[11px] uppercase tracking-[0.22em] text-[#957C5D] font-semibold">Where the project stands</div>
      <ol className="mt-5 grid gap-6 md:grid-cols-3 md:gap-0 relative">
        <div className="hidden md:block absolute top-[7px] left-[8%] right-[8%] h-px bg-[#D8D0C4]" />
        {steps.map((s) => (
          <li key={s.k} className="relative md:text-center" data-testid={`timeline-${s.k}`}>
            <div className={`h-[15px] w-[15px] rounded-full border-2 md:mx-auto ${s.done ? 'bg-[#957C5D] border-[#957C5D]' : 'bg-white border-[#B5AFA5]'}`} />
            <div className="mt-3 text-[11px] uppercase tracking-[0.18em] text-muted-foreground">{s.label}</div>
            <div className={`font-display font-semibold text-lg mt-0.5 ${s.date ? 'text-[#3A3936]' : 'text-[#B5AFA5]'}`}>{s.date ? formatDate(s.date) : 'To be confirmed'}</div>
            {s.note && <div className="text-xs text-muted-foreground mt-0.5 truncate">{s.note}</div>}
          </li>
        ))}
      </ol>
    </section>
  );
}
